import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    left: 0,
    top: 60,

    height: "100%",
    width: "100%",
  },

  wrapper: {
    position: "absolute",
    bottom: 100,
    right: 110,
    zIndex: 500,

    [theme.breakpoints.down("xs")]: {
      right: 0,
      left: 0,

      width: "90%",
      margin: "0 auto",
    },

    width: 350,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],

    padding: 20,

    "& a": {
      fontSize: 13,
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.secondary.main,

      "&:hover": {
        textDecoration: "none",
      },
    },
  },

  content: {
    fontSize: 13,
    fontWeight: theme.typography.fontWeightLight,
    margin: "18px 0",
  },

  overlay: {
    position: "absolute",
    left: 0,
    top: 0,
    zIndex: 100,

    height: "100%",
    width: "100%",
    backgroundColor: theme.palette.secondary.main,
    opacity: 0.1,
  },

  header: {
    "& img": {
      height: 20,
      width: 20,
    },

    "& span": {
      display: "inline-block",
      fontSize: 13,
      fontWeight: theme.typography.fontWeightMedium,

      marginLeft: 14,
    },
  },
}));

export const VerifyingWrapper = (props: any) => {
  const classes = useStyles(props);

  return (
    <Box className={classes.root}>
      <Box className={classes.wrapper}>
        <Box className={classes.header}>
          <img
            src={process.env.PUBLIC_URL + "/verifying.png"}
            alt="verifying.png"
          />
          <span>
            <FormattedMessage id="sharedScreen.verifyingYourAccount" />
          </span>
        </Box>
        <Box className={classes.content}>
          <span>
            <FormattedMessage id="sharedScreen.verifyingAccount" />
          </span>
        </Box>

        <Link to="">
          <FormattedMessage id="sharedScreen.contactICIPAdmin" />
        </Link>
      </Box>
      <Box className={classes.overlay} />
    </Box>
  );
};
